import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { reportError } from '@/lib/errorReporting';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    reportError({
      error_message: error?.message || String(error),
      stack_trace: error?.stack || null,
      endpoint: window.location.pathname,
      extra_context: { component_stack: errorInfo?.componentStack || null },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center min-h-screen bg-background px-4">
          <Card className="max-w-md w-full">
            <CardHeader className="items-center text-center">
              <AlertTriangle className="h-10 w-10 text-destructive mb-2" />
              <CardTitle>Algo salió mal</CardTitle>
              <CardDescription>
                Ocurrió un error inesperado. Ya quedó registrado para que el equipo lo revise.
              </CardDescription>
            </CardHeader>
            <CardContent className="flex justify-center gap-2">
              <Button variant="outline" onClick={() => { window.location.href = '/dashboard'; }}>
                Ir al inicio
              </Button>
              <Button onClick={() => window.location.reload()}>
                Recargar página
              </Button>
            </CardContent>
          </Card>
        </div>
      );
    }
    return this.props.children;
  }
}
